export enum Curve {
  'P-256' = 1,
  'P-384' = 2,
  'P-521' = 3,
  X25519 = 4,
  X448 = 5,
  Ed25519 = 6,
  Ed448 = 7,
}
